import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const agentProfitRangeList = (profitRangeData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "AGENT_PROFIT_RANGE_LIST_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent-profit-ranges/list`,
        profitRangeData,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "AGENT_PROFIT_RANGE_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCHED_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "AGENT_PROFIT_RANGE_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "AGENT_PROFIT_RANGE_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      if (showLoader) dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const agentProfitRangeAdd = (profitRangeData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "AGENT_PROFIT_RANGE_ADD_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent-profit-ranges/add`,
        profitRangeData,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "AGENT_PROFIT_RANGE_ADD_SUCCESS", payload: data });
        toast.success("Agent Profit Range Added Successfully!");
        return data;
      } else {
        dispatch({ type: "AGENT_PROFIT_RANGE_ADD_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "AGENT_PROFIT_RANGE_ADD_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const agentProfitRangeUpdate = (profitRangeData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "AGENT_PROFIT_RANGE_UPDATE_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent-profit-ranges/update/${profitRangeData.id}`,
        profitRangeData,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "AGENT_PROFIT_RANGE_UPDATE_SUCCESS", payload: data });
        toast.success("Agent Profit Range Updated Successfully!");
        return data;
      } else {
        dispatch({ type: "AGENT_PROFIT_RANGE_UPDATE_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "AGENT_PROFIT_RANGE_UPDATE_FAIL",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const agentProfitRangeRemove = (profitRangeId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "AGENT_PROFIT_RANGE_REMOVE_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent-profit-ranges/remove/${profitRangeId}`,
        {},
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "AGENT_PROFIT_RANGE_REMOVE_SUCCESS", payload: data });
        toast.success("Agent Profit Range Removed Successfully!");
        return data;
      } else {
        dispatch({ type: "AGENT_PROFIT_RANGE_REMOVE_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "AGENT_PROFIT_RANGE_REMOVE_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
